module.exports = __webpack_public_path__ + "img/part3-icon4-over.99b9cd43.png";